<div *ngIf="newHomePedirDelivery" class="new-design">
	<div id="menu-list" style="position: relative">
		<div *ngIf="featuredVisible.length">
			<div class="category-header">
				<h1 id="featuredItems" class="category-name">{{featuredItemsCategoryName}}</h1>
			</div>
			<div class="featured-carousel" appDragScroll>
				<ng-container *ngFor="let item of featuredVisible; trackBy: trackById">
					<span style="position: relative">
						<card
							[item]="item"
							[isFeatured]="true"
							[newHomePedirDelivery]="newHomePedirDelivery"
						></card>
					</span>
				</ng-container>
			</div>
		</div>
	</div>

	<div *ngIf="combosVisible.length">
		<div class="category-header">
			<h1 id="combos" class="category-name">{{comboCategoryName}}</h1>
		</div>
		<card
			*ngFor="let item of combosVisible; trackBy: trackById"
			style="width: 100%"
			[item]="item"
			[newHomePedirDelivery]="newHomePedirDelivery"
		></card>
	</div>

	<div *ngIf="pizzaSizesVisible.length">
		<div class="category-header">
			<h1 id="pizzas" class="category-name">{{pizzaCategoryName}}</h1>
		</div>
		<card *ngFor="let item of pizzaSizesVisible; trackBy: trackById" style="width: 100%" [item]="item" [newHomePedirDelivery]="newHomePedirDelivery">
		</card>
	</div>

	<!-- `generalView` contém só as categorias já INICIADAS pelo render progressivo (a
	     última pode estar parcial). O `| slice:0:visibleGeneralLimit` que ficava aqui
	     saiu: era redundante e o SlicePipe é impuro (rodava a cada change detection). -->
	<div
        *ngFor="let view of generalView; trackBy: trackByCategory"
		style="position: relative"
		id="{{view.category.name}}-{{view.category.id}}"
	>
		<!-- `mpCategoryCards` é a fronteira OnPush da categoria: o cabeçalho abaixo é
		     PROJETADO (continua deste template e com o estilo deste componente) e os
		     cards vêm em fatias OnPush de 48 depois dele. O `<span style="position:relative">`
		     que envolvia cada card saiu no Caso 17 — o overlay do item indisponível vive no
		     próprio card (`.product-card-new-design { position: relative }`). -->
		<div
			*ngIf="view.hasProducts"
			class="scroll-category"
			mpCategoryCards
			[view]="view"
			[revision]="view.revision"
			[newHomePedirDelivery]="newHomePedirDelivery"
		>
			<div class="category-header">
				<h1 [id]="view.category.id" class="category-name">{{view.category.name}}</h1>
				<p *ngIf="view.hasDescription && !isInstagramUA" class="text-wrap category-description" [innerHTML]="view.descriptionHtml"></p>
				<p *ngIf="view.hasDescription && isInstagramUA" class="text-wrap category-description">{{view.descriptionText}}</p>
			</div>
		</div>
	</div>
</div>

<!-- O `<span style="position:relative">` que envolvia CADA card também saiu do
     layout legado (Caso 17-B) — 1 nó por produto, ~1.950 numa distribuidora.
     Aqui ele nunca chegou a servir para nada: era bloco de contenção do overlay
     do item indisponível (`.product-card--disabled::after`), mas esse pseudo
     pende do próprio `<ion-card>`, que o Ionic já entrega com
     `position: relative` (e `contain: content`). Diferente do carrossel de
     destaques do layout NOVO, onde `.featured-carousel span { flex: 0 0 170px }`
     dimensiona o item e o span FICA: o legado não tem carrossel. -->
<ion-list id="menu-list" style="position: relative" *ngIf="!newHomePedirDelivery">
	<ion-item-group *ngIf="featuredVisible.length">
		<h1 id="featuredItems" class="category-name">{{featuredItemsCategoryName}}</h1>
		<card
			*ngFor="let item of featuredVisible; trackBy: trackById"
			style="width: 100%"
			[item]="item"
			[newHomePedirDelivery]="newHomePedirDelivery"
		></card>
	</ion-item-group>

	<ion-item-group *ngIf="combosVisible.length">
		<h1 id="combos" class="category-name">{{comboCategoryName}}</h1>
		<card
			*ngFor="let item of combosVisible; trackBy: trackById"
			style="width: 100%"
			[item]="item"
			[newHomePedirDelivery]="newHomePedirDelivery"
		></card>
	</ion-item-group>

	<ion-item-group *ngIf="pizzaSizesVisible.length">
		<h1 id="pizzas" class="category-name">{{pizzaCategoryName}}</h1>
		<card *ngFor="let item of pizzaSizesVisible; trackBy: trackById" style="width: 100%" [item]="item" [newHomePedirDelivery]="newHomePedirDelivery">
		</card>
	</ion-item-group>

	<!-- Mesmo desenho do layout novo: `mpCategoryCards` (OnPush) projeta o cabeçalho e
	     põe os cards em fatias OnPush de 48. -->
	<ion-item-group
        *ngFor="let view of generalView; trackBy: trackByCategory"
		style="position: relative"
		id="{{view.category.name}}-{{view.category.id}}"
	>
		<div
			*ngIf="view.hasProducts"
			class="scroll-category"
			mpCategoryCards
			[view]="view"
			[revision]="view.revision"
			[newHomePedirDelivery]="newHomePedirDelivery"
		>
			<h1 [id]="view.category.id" class="category-name">{{view.category.name}}</h1>
			<ion-label *ngIf="view.hasDescription && !isInstagramUA" class="text-wrap category-description"><span [innerHTML]="view.descriptionHtml"></span></ion-label>
			<ion-label *ngIf="view.hasDescription && isInstagramUA" class="text-wrap category-description">{{view.descriptionText}}</ion-label>
		</div>
	</ion-item-group>
</ion-list>

<app-featured-coupon-popup></app-featured-coupon-popup>
